export enum DeviceType {
  POS = 3,
  HOME_DELIVERY = 12,
  SELF_SCANNING = 13,
  DRIVE = 15,
  RESTAURANT = 17,
  BAR = 18,
  SCO = 20,
  BAR_SELF = 22,
  MONITOR = 23,
  BAR_COMANDA = 24,
  CASH_CARRY = 25,
  KIOSK_SELF_ORDER = 26,
}
